/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetTestDto } from './GetTestDto';
import {
    GetTestDtoFromJSON,
    GetTestDtoFromJSONTyped,
    GetTestDtoToJSON,
} from './GetTestDto';
import type { GetUserDto } from './GetUserDto';
import {
    GetUserDtoFromJSON,
    GetUserDtoFromJSONTyped,
    GetUserDtoToJSON,
} from './GetUserDto';
import type { GetExamDto } from './GetExamDto';
import {
    GetExamDtoFromJSON,
    GetExamDtoFromJSONTyped,
    GetExamDtoToJSON,
} from './GetExamDto';

/**
 * 
 * @export
 * @interface GetExamTestDto
 */
export interface GetExamTestDto {
    /**
     * 
     * @type {string}
     * @memberof GetExamTestDto
     */
    id: string;
    /**
     * 
     * @type {GetExamDto}
     * @memberof GetExamTestDto
     */
    exam?: GetExamDto | null;
    /**
     * 
     * @type {GetTestDto}
     * @memberof GetExamTestDto
     */
    test?: GetTestDto | null;
    /**
     * 
     * @type {number}
     * @memberof GetExamTestDto
     */
    lp?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof GetExamTestDto
     */
    startDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetExamTestDto
     */
    endDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamTestDto
     */
    startVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamTestDto
     */
    endVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetExamTestDto
     */
    criticalPoint?: string | null;
    /**
     * 
     * @type {GetUserDto}
     * @memberof GetExamTestDto
     */
    owner?: GetUserDto | null;
}

/**
 * Check if a given object implements the GetExamTestDto interface.
 */
export function instanceOfGetExamTestDto(value: object): value is GetExamTestDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetExamTestDtoFromJSON(json: any): GetExamTestDto {
    return GetExamTestDtoFromJSONTyped(json, false);
}

export function GetExamTestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetExamTestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'exam': json['exam'] == null ? undefined : GetExamDtoFromJSON(json['exam']),
        'test': json['test'] == null ? undefined : GetTestDtoFromJSON(json['test']),
        'lp': json['lp'] == null ? undefined : json['lp'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'startVersion': json['startVersion'] == null ? undefined : json['startVersion'],
        'endVersion': json['endVersion'] == null ? undefined : json['endVersion'],
        'criticalPoint': json['criticalPoint'] == null ? undefined : json['criticalPoint'],
        'owner': json['owner'] == null ? undefined : GetUserDtoFromJSON(json['owner']),
    };
}

export function GetExamTestDtoToJSON(value?: GetExamTestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'exam': GetExamDtoToJSON(value['exam']),
        'test': GetTestDtoToJSON(value['test']),
        'lp': value['lp'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate'] as any).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate'] as any).toISOString()),
        'startVersion': value['startVersion'],
        'endVersion': value['endVersion'],
        'criticalPoint': value['criticalPoint'],
        'owner': GetUserDtoToJSON(value['owner']),
    };
}

